import { connect } from "react-redux";
import Login from "./Login";
import {
  loginRequest,
  loginRedirectReset,
  loginErrorReset,
} from "../../Login/loginActions";
import {
  googleAuthRequest,
  googleAuthReset,
  socialAuthErrorReset,
} from "../../SocialAuth/socialAuthActions";

const mapStateToProps = (state) => ({
  auth: state.auth,
  socialAuth: state.socialAuth,
});

const mapDispatchToProps = {
  login: loginRequest,
  loginRedirectReset,
  loginErrorReset,
  googleAuth: googleAuthRequest,
  googleAuthReset,
  socialAuthErrorReset,
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);
